// extracted by mini-css-extract-plugin
module.exports = {"notfound":"notfound__dU_0i"};